<template>
  <va-card :title="$t('tables.historic') + ' ' + $t('tables.orders.code') + ' ' + this.$route.params.order">
    <div class="row">
      <div class="flex md2 sm6 xs12">
      <va-button
      v-if="this.$route.params.assemblyLine == 1"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'mounting', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 2"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'conferencing', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 3"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'stacking', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 4"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'layer_picking', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 5"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'conference_supervision', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 6"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'vehicle_liberation', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 7"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'transporting', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 8"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'finished', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 10"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'loads', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
        
      </div>
    </div>
    <va-timeline vertical>
      <va-timeline-item v-for="(item, index) in order_histories" :key="item.id">

        <template :slot="index%2 === 0 ? 'before' : 'after'">
          <va-card
            stripe="danger"
            :title="`${item.step_name}`">

            {{ item.history_name }}
              
            <span style="float:right;">
              {{ item.user_name }}
              <va-icon name="fa fa-user" size="60" style="margin-left:5px"/>
              </span>
          </va-card>
          
        </template>

        <div :slot="index%2 !== 0 ? 'before' : 'after'" :style="index%2 !== 0 ? 'float:right' : ''">
          {{ item.date }}
        </div>

      </va-timeline-item>
    </va-timeline>
  </va-card>
</template>

<script>
import OrdersAPI from '@/services/OrdersAPI'
export default {
  data() {
    return {
      order_histories: []
    }
  },

  mounted () {
    OrdersAPI.getOrderHistorieByOrder(this.$route.params.orderId).then(response => {
      this.order_histories = response.data.order_histories
    })
  },
}
</script>